import DocxViewer from "../components/DocxView/DocxView"

 const index=()=>{
    return (
      <DocxViewer docxFile={'/static/word1.docx'}  ></DocxViewer>
    )
}

export default index